import React, { useState, useEffect } from "react";
import { requestPermission, onMessageListener } from "../firebase";
import useToastContext from "hooks/useToastContext";
import { ToastContextProvider } from "context/ToastContext";

function Notification() {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const notifications = useToastContext();

  useEffect(() => {
    let active = true;

    (async () => {
      const token = await requestPermission(); // call once, safely
      // token can be null on unsupported browsers -> no crash

      const payloadPromise = await onMessageListener();
      if (!payloadPromise) return;

      payloadPromise.then((payload) => {
        if (!active) return;

        const title = payload?.notification?.title || "";
        const body = payload?.notification?.body || "";

        setNotification({ title, body });

        notifications.success(`${title}: ${body}`, {
          duration: 60000,
          position: "top-right",
        });
      });
    })();

    return () => {
      active = false;
    };
  }, [notifications]);

  return (
    <div>
      <h2>{notification.title}</h2>
      <p>{notification.body}</p>
      <ToastContextProvider />
    </div>
  );
}

export default Notification;